@if (products().length) {
  <div class="tw-pt-4 tw-pb-4 tw-pl-4 tw-font-body tw-bg-gradient-cream-to-white">
    <div class="tw-flex tw-items-center tw-gap-2 tw-pr-4 tw-cursor-pointer" (click)="viewAllRefill()">
      <div class="tw-relative tw-h-10 tw-w-10 tw-flex-shrink-0">
        <img class="tw-absolute tw-left-1/2 tw-top-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2 tw-h-12 tw-w-12 tw-object-cover" src="/assets/gifs/refill-clock.gif" alt="" />
      </div>
      <div class="tw-flex tw-flex-col tw-flex-1 tw-min-w-0">
        <p class="tw-font-lexend tw-font-bold tw-text-400 tw-leading-[19.2px] tw-text-gray-800" i18n="@@timeToRefill">Time to Refill</p>
        <p class="tw-text-200 tw-leading-[18px] tw-text-gray-500 tw-opacity-80" i18n="@@reorderYourProductsNow">Reorder your products now</p>
      </div>
      <cs-icon class="tw-w-6 tw-h-6 tw-text-teal-500 tw-flex-shrink-0" [iconName]="'chevron_right'" />
    </div>

    <div class="tw-h-[128px] tw-flex tw-gap-2 tw-overflow-x-auto tw-overflow-y-hidden tw-w-full tw-mt-3">
      @for (item of products(); track item.product.objectId) {
        <app-horizontal-product-card [product]="item.product" [fullBleedImage]="true" [quantity]="getQuantity(item)"
          (add)="onAdd($event)" (remove)="onRemove($event)" (view)="viewProductDetail($event)">
          <h2 card-tag class="cart-page-tag-bg-gradient tw-h-4 tw-w-fit tw-flex tw-items-center tw-text-50 tw-px-[5px] tw-font-medium tw-rounded-1 tw-mb-1 tw-text-gray-500">
            <span i18n="@@purchasedDaysAgo">Purchased {{ item.daysSincePurchase }} days ago</span>
          </h2>
        </app-horizontal-product-card>
      }
    </div>
  </div>
}
